{
  "clubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
  "ratingSeasonId": "00000000-0000-4000-8000-000000000101",
  "formation": "4-4-2",
  "formationVersion": 1,
  "players": [
    {
      "slot": 1,
      "playerInstanceId": "a21ec976-479f-210b-b8f3-bde617403611"
    },
    {
      "slot": 2,
      "playerInstanceId": "8ba9e687-82fb-44aa-96e4-62d7f9585219"
    },
    {
      "slot": 3,
      "playerInstanceId": "8fa52912-080f-be1b-db73-065e34a67046"
    },
    {
      "slot": 4,
      "playerInstanceId": "a904ae0a-1040-bdd2-668b-92cf29b1727f"
    },
    {
      "slot": 5,
      "playerInstanceId": "e2725664-993e-a3bb-220b-a3f7d1a5b3a0"
    },
    {
      "slot": 6,
      "playerInstanceId": "0302a568-018b-39e7-db58-cdd5509290e9"
    },
    {
      "slot": 7,
      "playerInstanceId": "2c6a8a81-fdaf-763d-12e4-d8d245229b0f"
    },
    {
      "slot": 8,
      "playerInstanceId": "5e778a66-9561-0d80-2d90-cf2fedf749f5"
    },
    {
      "slot": 9,
      "playerInstanceId": "6774caaf-918c-47ec-9ecb-902434156733"
    },
    {
      "slot": 10,
      "playerInstanceId": "3c0493bf-c27e-4d4f-982a-8dfd95b24e70"
    },
    {
      "slot": 11,
      "playerInstanceId": "639f5c8e-c4fb-4052-9731-5d583579edef"
    }
  ]
}
